// Вспомогательные функции для работы с токенами

export interface TokenData {
    access_token: string
    refresh_token?: string
}

/**
 * Берёт самую свежую OAuth2-сессию из массива tokens[] (auth_v2 добавляет в конец).
 */
function pickLatestOAuth2Token(tokens: any[]): any | null {
    if (!tokens?.length) {
        return null;
    }

    return [...tokens].sort((a, b) => {
        const aTime = new Date(a.last_used || a.created_at || 0).getTime();
        const bTime = new Date(b.last_used || b.created_at || 0).getTime();
        return bTime - aTime;
    })[0];
}

/**
 * Определяет тип токена пользователя и формирует правильную структуру для finishAuth
 * @param user - объект пользователя или роли
 * @returns TokenData для передачи в finishAuth
 */
export function prepareTokenData(user: any): TokenData {
    // Если у пользователя есть массив tokens (OAuth2), берём самую свежую сессию
    const token = pickLatestOAuth2Token(user.tokens);
    if (token) {
        return {
            access_token: token.access_token,
            refresh_token: token.refresh_token
        };
    }
    
    // Если есть только access_token (старый формат)
    if (user.access_token) {
        return {
            access_token: user.access_token
        };
    }
    
    // Fallback - возвращаем пустой объект
    console.warn('prepareTokenData: Не удалось определить тип токена для пользователя:', user);
    return {
        access_token: ''
    };
}

/**
 * Проверяет, является ли пользователь мигрированным на OAuth2
 * @param user - объект пользователя или роли
 * @returns true если пользователь мигрирован на OAuth2
 */
export function isOAuth2User(user: any): boolean {
    return !!(user.tokens && Array.isArray(user.tokens) && user.tokens.length > 0);
}
